import type { AskCancelOutput, ConfirmCancelInput, TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useState } from 'react';

import { AskStep } from './AskStep';
import { ReasonStep } from './ReasonStep';
import { Modal } from '../../../components/Modal';
import { noop } from '../../../utils/common';

type Props = {
  trip: TripOutput;
  cancelRequest: AskCancelOutput;
  onClose: () => void;
  onConfirm: (_input: ConfirmCancelInput) => void;
  isLoading: boolean;
};

export const CancelTripModal = ({ trip, cancelRequest, onClose, onConfirm, isLoading }: Props) => {
  const [step, setStep] = useState<'ask' | 'reason'>('ask');

  const Step =
    step === 'ask' ? (
      <AskStep trip={trip} cancelRequest={cancelRequest} onConfirm={() => setStep('reason')} onCancel={onClose} />
    ) : (
      <ReasonStep
        tripKey={trip.key}
        cancelRequest={cancelRequest}
        onCancel={() => setStep('ask')}
        isLoading={isLoading}
        onConfirm={onConfirm}
      />
    );

  return <Modal onClose={isLoading ? noop : onClose}>{Step}</Modal>;
};
